export enum XmlSchemaNamedType {
  XmlSchemaElement,
  XmlSchemaAttribute,
  XmlSchemaType,
  XmlSchemaAttributeGroup,
  XmlSchemaGroup,
  XmlSchemaNotation,
}
